/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function BugDroid(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M47.92969,128h160v20a80,80,0,0,1-160,0Z" opacity={0.2} />
      <Path
        d="M207.92969,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={207.92969}
        y1={128}
        x2={47.92969}
        y2={128}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Circle cx={155.92969} cy={91.99998} r={12} />
      <Circle cx={99.92969} cy={91.99998} r={12} />
      <Line
        x1={55.92969}
        y1={28}
        x2={76.24389}
        y2={46.93601}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={199.92969}
        y1={28}
        x2={179.61507}
        y2={46.93662}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default BugDroid;
